import { Bits } from './Bits';
/**
 * 组件类型管理器
 * 负责管理组件类型的注册和ID分配
 */
export class ComponentTypeManager {
    /**
     * 获取单例实例
     */
    static get instance() {
        if (!ComponentTypeManager._instance) {
            ComponentTypeManager._instance = new ComponentTypeManager();
        }
        return ComponentTypeManager._instance;
    }
    constructor() {
        this._componentTypes = new Map();
        this._typeNames = new Map();
        this._nextTypeId = 0;
    }
    /**
     * 获取组件类型的ID
     * @param componentType 组件类型构造函数
     * @returns 组件类型ID
     */
    getTypeId(componentType) {
        let typeId = this._componentTypes.get(componentType);
        if (typeId === undefined) {
            typeId = this._nextTypeId++;
            this._componentTypes.set(componentType, typeId);
            this._typeNames.set(typeId, componentType.name);
        }
        return typeId;
    }
    /**
     * 获取组件类型名称
     * @param typeId 组件类型ID
     * @returns 组件类型名称
     */
    getTypeName(typeId) {
        return this._typeNames.get(typeId) || 'Unknown';
    }
    /**
     * 创建包含指定组件类型的Bits对象
     * @param componentTypes 组件类型构造函数数组
     * @returns Bits对象
     */
    createBits(...componentTypes) {
        const bits = new Bits();
        for (const componentType of componentTypes) {
            const typeId = this.getTypeId(componentType);
            bits.set(typeId);
        }
        return bits;
    }
    /**
     * 获取实体的组件位掩码
     * @param components 组件数组
     * @returns Bits对象
     */
    getEntityBits(components) {
        const bits = new Bits();
        for (const component of components) {
            const typeId = this.getTypeId(component.constructor);
            bits.set(typeId);
        }
        return bits;
    }
    /**
     * 重置管理器（主要用于测试）
     */
    reset() {
        this._componentTypes.clear();
        this._typeNames.clear();
        this._nextTypeId = 0;
    }
    /**
     * 获取已注册的组件类型数量
     */
    get registeredTypeCount() {
        return this._componentTypes.size;
    }
}
//# sourceMappingURL=ComponentTypeManager.js.map